export default __webpack_public_path__ + "static/media/vip.e8119425.webp";